module.exports = __webpack_public_path__ + "static/media/stream_xtendbarre_video_classes.bb583847.svg";